export default __webpack_public_path__ + "static/media/Mercenary's Legguards of the Savage Sun.8b283db2.jpg";